import React from "react";
import ContentLoader from "react-content-loader";

export const LogoLoader = ({ ...rest }) => (
  <ContentLoader width="300" height="107" viewBox="0 0 300 107" {...rest}>
    <rect x="15" y="15" rx="4" ry="4" width="300" height="107" />
  </ContentLoader>
);
